import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('app.orgprovinces'),
      path: 'configurations/orgprovinces',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/orgprovinces/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.historical'),
          path: 'configurations/orgprovinces/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
